import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { TheTrap } from './TheTrap';
import { OldSolutions } from './OldSolutions';
import { Sistema3C } from './Sistema3C';
import { WhatsIncluded } from './WhatsIncluded';
import { WhoItsFor } from './WhoItsFor';
import { HowToUse } from './HowToUse';
import { PricingCTA } from './PricingCTA';
import { SalesToast } from './SalesToast';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-84">
      <Hero data-id="element-85" />
      <PainPoints data-id="element-86" />
      <TheTrap data-id="element-87" />
      <OldSolutions data-id="element-88" />
      <Sistema3C data-id="element-89" />
      <WhatsIncluded data-id="element-90" />
      <WhoItsFor data-id="element-91" />
      <HowToUse data-id="element-92" />
      <PricingCTA data-id="element-93" />

      <footer className="py-8 text-center text-brown-body/40 text-sm" data-id="element-94">
        <p data-id="element-95">
          © {new Date().getFullYear()} Semana Resuelta. Todos los derechos
          reservados.
        </p>
      </footer>

      <SalesToast data-id="element-96" />
    </main>;
}